import React from "react";
import ReadonlyFileRowCard from "./ReadonlyFile";

interface Props {
  files: server.dto.ESignFile[]
}

const ReadonlyFileList = (props: Props) => {
  return <div className="list-with-gaps line-layout">
    <div className="list-with-gaps-body">
      {props.files.map(file => (
        <ReadonlyFileRowCard
          key={file.eSignFileId}
          file={file}
        />
      ))}
    </div>
  </div >;
};

export default ReadonlyFileList;